import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarText from '../components/NavbarText';
import axios from "axios";
import * as securityHelper from "../helper/SecurityHelper";
import SgstDtl from '../components/suggestions/SgstDtl';
import SgstRgst from '../components/suggestions/SgstRgst';
import SgstList from '../components/suggestions/SgstList';
import Snackbar from '../components/Snackbar';

interface Suggest {
  evntName: string;
  comName: string;
  place: string;
  reporter: string;
  reception: string;
  section: string;
  content: string;
  image: string;
  status: string;
}

export default function Suggestions() {
  const navigate = useNavigate();
  const user = securityHelper.getLoginUser();
  const [box, setBox] = useState(true);
  const [suggest, setSuggest] = useState<Suggest[]>();
  const [detail, setDetail] = useState(false);
  const [detailData, setDetailData] = useState<Suggest>();
  const [rgst, setRgst] = useState(false);
  const [statusTab, setStatusTab] = useState('받은 건의');
  const [snackbarTxt, setSnackbarTxt] = useState('');
  useEffect(() => {
    if (snackbarTxt) {
      setTimeout(() => setSnackbarTxt(''), 2000)
    }
  }, [snackbarTxt]);

  const backEvent = () => {
    if (!detail) { navigate(-1) }
    else { setDetail(false) };
  }
  useEffect(() => {
    fn_retrieveSgstDataList();
  }, [box, detail, statusTab])

  const fn_retrieveSgstDataList = async () => {
    let param = { auth: user.auth, rgstrSeq: -1, rcptntSeq: -1 };
    if (user.auth === 'WOK') {
      param.rgstrSeq = user.seq;
    } else {
      if (statusTab === '보낸 건의') {
        param.rgstrSeq = user.seq;
      }
      param.rcptntSeq = user.companySeq
    }
    const rtrnData = await axios.post('admin/api/sgst/retrieveSgstDataList', param);
    setSuggest(rtrnData.data);
  }

  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      <NavbarText backEvent={backEvent}>건의사항</NavbarText>
      <div className='top-52 flex mb-12 md:mb-[30px] flex-col items-center pt-10 md:pt-[25px]'>
        {user.auth === 'WOK' ? null
          : <div className='flex'>
            <StatusBtn statusTab={statusTab} setStatusTab={setStatusTab} setBox={setBox} setRgst={setRgst} setDetail={setDetail}>받은 건의</StatusBtn>
            <StatusBtn statusTab={statusTab} setStatusTab={setStatusTab} setBox={setBox} setRgst={setRgst} setDetail={setDetail}>보낸 건의</StatusBtn>
          </div>}
        {!rgst &&
          <div className='flex justify-end w-[90%] pt-12 md:pt-[30px]'>
            <button
              onClick={() => { setBox(false); setRgst(true); setDetail(false); }}
              className='w-85 md:w-[212px] h-32 md:h-[80px] text-14 md:text-35 leading-16 md:leading-[40px] rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo mr-9 md:mr-[22px]'>건의하기</button>
          </div>}
      </div>
      {detail
        ? <SgstDtl detailData={detailData} setDetail={setDetail} setSnackbarTxt={setSnackbarTxt} auth={user.auth} />
        : (rgst
          ? <SgstRgst setBox={setBox} setRgst={setRgst} setSnackbarTxt={setSnackbarTxt} auth={user.auth} />
          : <SgstList suggest={suggest} setDetail={setDetail} setDetailData={setDetailData} auth={user.auth} />)
      }
    </div>
  );
}

const StatusBtn = ({ children, statusTab, setStatusTab, setBox, setRgst, setDetail }: any) => {
  return <button onClick={() => { setBox(true); setRgst(false); setStatusTab(children); setDetail(false); }}
    className={statusTab === '받은 건의'
      ? children === '받은 건의'
        ? 'border rounded-l-[5px] md:rounded-l-[12px] border-[#2F2F35] bg-[#2F2F35] text-white text-14 w-159 h-36 md:text-35 md:w-[397px] md:h-[90px] font-preLight'
        : 'border border-l-0 rounded-r-[5px] md:rounded-r-[12px] border-[#2F2F35] bg-transparent text-[#464649] text-14 w-159 h-36 md:text-35 md:w-[397px] md:h-[90px] font-preLight'
      : children === '보낸 건의'
        ? 'border rounded-r-[5px] md:rounded-r-[12px] border-[#2F2F35] bg-[#2F2F35] text-white text-14 w-159 h-36 md:text-35 md:w-[397px] md:h-[90px] font-preLight'
        : 'border border-r-0 rounded-l-[5px] md:rounded-l-[12px] border-[#2F2F35] bg-transparent text-[#464649] text-14 w-159 h-36 md:text-35 md:w-[397px] md:h-[90px] font-preLight'}>{children}</button>;
};
